/** Which API resource a question came from. General questions have no `dealOpportunityId`. */
export enum QuestionScope {
    DEAL = 'deal',
    GENERAL = 'general'
}

/** Deal questions only — topic within the deal. */
export enum DealQuestionType {
    COMMERCIAL = 0,
    FINANCIAL = 1,
    LEGAL = 2,
    OTHER = 3
}

/** Shared by both resources. */
export enum QuestionStatus {
    OPEN = 0,
    ANSWERED = 1,
    CLOSED = 2
}

/** Shared by both resources. Values align with the app-wide `Role` bucket enum. */
export enum QuestionRole {
    ADMIN = 0,
    WEALTH_MANAGER = 1,
    RELATIONSHIP_MANAGER = 2,
    CLIENT = 3
}

/** General questions only. */
export enum GeneralQuestionCategory {
    COMPLIANCE_ONBOARDING = 0,
    OTHER = 1
}

/**
 * Top-level tab on the questions list. Deliberately mirrors `AskQuestionTopic` so the
 * buckets people browse are the same ones they picked from when raising the question.
 */
export enum QuestionTab {
    DEALS = 'deals',
    ONBOARDING = 'onboarding',
    OTHER = 'other'
}

/**
 * "What is this about?" in the raise form. Only the topics the API can actually represent:
 * DEAL routes to the deal resource, the other two are `GeneralQuestionCategory` values.
 */
export enum AskQuestionTopic {
    DEAL = 'deal',
    COMPLIANCE_ONBOARDING = 'compliance-onboarding',
    OTHER = 'other'
}
